import { Notyf } from "notyf";
import 'notyf/notyf.min.css';

const LogosNotification = {
    Success(message: string) {
        var notyf = new Notyf({ duration: 5000 });
        notyf.success(message);
    },

    Error(message: string) {
        var notyf = new Notyf({ duration: 5000 });
        notyf.error(message);
    }
}
export default LogosNotification;